module.exports = "/_next/static/images/OptimizedForCost@2x-3b8a3ccd30962b24c458298c912253e1.webp";